import React from 'react'
import './styles/IconsBarSection.css'
import IconContainer from "./IconContainer"

export default function IconsBarSection({ title='', subtitle='', data }) {

  const iconsBarRender = data?.map((item, index) => {
    return <div
      key={index}
      className="icon-bar-item"
    >
      <IconContainer
        icon={item.icon}
        dimensions={45}
        iconSize="21"
        iconColor="var(--primary)"
        bgColor="var(--extraLightPrimary)"
      />
      <h5>{item.title}</h5>
      <small>{item.text}</small>
    </div>
  })

  return (
    <div className="icons-bar-section">
      <h5>{subtitle}</h5>
      <h2>{title}</h2>
      <div className="icons-bar-flex">
        {iconsBarRender}
      </div>
    </div>
  )
}
